// src/components/layout/Navigation.jsx
import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Edit3, 
  Image, 
  Calendar, 
  Settings
} from 'lucide-react';

const Navigation = () => {
  const navigationItems = [
    {
      name: 'Dashboard',
      href: '/dashboard',
      icon: LayoutDashboard,
      description: 'Vue d\'ensemble'
    },
    {
      name: 'Éditeur',
      href: '/editor',
      icon: Edit3,
      description: 'Créer des templates'
    },
    {
      name: 'Médias',
      href: '/media',
      icon: Image,
      description: 'Gérer les fichiers'
    },
    {
      name: 'Planification',
      href: '/scheduler',
      icon: Calendar,
      description: 'Programmer le contenu'
    },
    {
      name: 'Paramètres',
      href: '/settings',
      icon: Settings,
      description: 'Configuration'
    }
  ];

  return (
    <nav className="layout-navigation">
      <div className="px-6">
        <div className="flex space-x-8">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) => {
                  // Gestion spéciale pour la route racine qui doit activer Dashboard
                  const isActiveRoute = isActive || (item.href === '/dashboard' && window.location.pathname === '/');
                  
                  return `flex items-center space-x-2 py-4 px-2 border-b-2 font-medium text-sm transition-colors ${
                    isActiveRoute
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`;
                }}
                title={item.description}
              >
                <Icon className="h-4 w-4" />
                <span>{item.name}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;